{
	"invalid": "Statut invalide",
	"offline": "hors ligne",
	"online": "en ligne"
}
